import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e3eef846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iv" }
const _hoisted_2 = {
  key: 0,
  class: "iv__row-activation"
}
const _hoisted_3 = {
  key: 0,
  class: "iv__tabs"
}
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = { class: "iv__instance" }
const _hoisted_6 = {
  key: 0,
  class: "iv__instance-loader"
}
const _hoisted_7 = {
  key: 1,
  class: "iv__pagination"
}
const _hoisted_8 = {
  key: 2,
  class: "iv__pagination-m"
}
const _hoisted_9 = {
  key: 3,
  class: "iv__page-select-m"
}
const _hoisted_10 = {
  key: 4,
  class: "iv__activation-m"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_EllipsisLoader = _resolveComponent("EllipsisLoader")!
  const _component_InstanceTable = _resolveComponent("InstanceTable")!
  const _component_InstanceTableMob = _resolveComponent("InstanceTableMob")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_PageSelect = _resolveComponent("PageSelect")!
  const _component_UiFilter = _resolveComponent("UiFilter")!
  const _component_ModalMobileFilters = _resolveComponent("ModalMobileFilters")!
  const _component_ModalActivateChannel = _resolveComponent("ModalActivateChannel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.device.isMobile ? 'iv__row-m' : 'iv__row')
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.device.isMobile ? 'iv__row-label-m' : 'iv__row-label')
        }, " Инстансы ", 2),
        (
					!_ctx.isAdmin() &&
					!_ctx.device.isMobile &&
					undefined !== _ctx.tariffType &&
					1 !== _ctx.tariffType
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_UiButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickRedirect('payment'))),
                label: "Купить канал",
                "background-color": "var(--theme-color)",
                "border-color": "var(--theme-color)",
                color: "rgb(255, 255, 255)",
                "font-weight": "600",
                "font-size": "16px"
              })
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.isShowChannelTabs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleChannelTabs, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.channel,
                type: "button",
                class: _normalizeClass({
					'iv__tabs-item': true,
					'iv__tabs-item_active': _ctx.channel === tab.channel,
					'iv__tabs-item_pending': _ctx.pendingChannel === tab.channel,
				}),
                disabled: _ctx.isInstanceListLoading,
                onClick: ($event: any) => (_ctx.onClickChannelTab(tab.channel))
              }, _toDisplayString(tab.name), 11, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isListLoaderVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_EllipsisLoader, { color: "var(--theme-color)" })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.device.isMobile)
          ? (_openBlock(), _createBlock(_component_InstanceTable, {
              key: 1,
              items: _ctx.instances,
              channel: _ctx.channel,
              onSelectedFilters: _ctx.onClickSelectedFilters
            }, null, 8, ["items", "channel", "onSelectedFilters"]))
          : _createCommentVNode("", true),
        (_ctx.device.isMobile)
          ? (_openBlock(), _createBlock(_component_InstanceTableMob, {
              key: 2,
              items: _ctx.instances
            }, null, 8, ["items"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.device.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Paginator, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.instances.pageCount,
              onSelectedPage: _ctx.onClickPagination
            }, null, 8, ["current-page", "total-pages", "onSelectedPage"]),
            _createVNode(_component_PageSelect, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.instances.pageCount,
              onSelectedPage: _ctx.onClickPagination
            }, null, 8, ["current-page", "total-pages", "onSelectedPage"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.device.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Paginator, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.instances.pageCount,
              onSelectedPage: _ctx.onClickPagination
            }, null, 8, ["current-page", "total-pages", "onSelectedPage"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.device.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_PageSelect, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.instances.pageCount,
              onSelectedPage: _ctx.onClickPagination
            }, null, 8, ["current-page", "total-pages", "onSelectedPage"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.device.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (!_ctx.isAdmin())
              ? (_openBlock(), _createBlock(_component_UiButton, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickRedirect('payment'))),
                  class: "iv__activation-m-btn",
                  label: "Купить канал",
                  "background-color": "var(--theme-color)",
                  "border-color": "var(--theme-color)",
                  color: "rgb(255, 255, 255)",
                  "font-weight": "600",
                  "font-size": "16px"
                }))
              : _createCommentVNode("", true),
            _hoisted_11,
            _createVNode(_component_UiFilter, { onClick: _ctx.onClickShowModalFilters }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.device.isMobile && _ctx.modalMobileFilters.isShow)
      ? (_openBlock(), _createBlock(_component_ModalMobileFilters, {
          key: 0,
          items: _ctx.instances,
          channel: _ctx.channel,
          onSelectedFilters: _ctx.onClickSelectedFilters
        }, null, 8, ["items", "channel", "onSelectedFilters"]))
      : _createCommentVNode("", true),
    (_ctx.modalActivateChannel.isShow)
      ? (_openBlock(), _createBlock(_component_ModalActivateChannel, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}